import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FEDERATION } from '@/lib/api';

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-16 md:py-24">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-display uppercase text-[12vw] md:text-[8vw] leading-[0.85] tracking-tighter"
        >
          Join the<br />Federation.
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-10 border-t border-white/10 pt-10">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50 mb-3">Contact</p>
            <p className="text-sm text-white/80">{FEDERATION.email}</p>
            <p className="text-sm text-white/80">{FEDERATION.phone}</p>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50 mb-3">Explore</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/register" className="hover:text-[#CCFF00] transition-colors">Register</Link></li>
              <li><Link to="/track" className="hover:text-[#CCFF00] transition-colors">Track Application</Link></li>
              <li><Link to="/live" className="hover:text-[#CCFF00] transition-colors">Live Scoreboard</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50 mb-3">Head Office</p>
            <p className="text-sm text-white/80">Shiv Nagar, Gwalior<br />Madhya Pradesh — 474002</p>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50 mt-4 mb-3">Branch Office</p>
            <p className="text-sm text-white/80">G-3 Ganpati Plaza, City Center<br />Gwalior, Madhya Pradesh — 474011</p>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/50 mb-3">Registered</p>
            <p className="font-display text-3xl">Reg. {FEDERATION.reg}</p>
            <p className="font-mono text-[10px] uppercase tracking-widest text-white/50 mt-3">Est. 2025</p>
          </div>
        </div>

        <div className="mt-10 flex flex-col md:flex-row justify-between gap-4 border-t border-white/10 pt-6 font-mono text-[11px] uppercase tracking-widest text-white/40">
          <span>© {new Date().getFullYear()} {FEDERATION.name} — All rights reserved.</span>
          <span>Made for athletes. Built for champions.</span>
        </div>
      </div>
    </footer>
  );
}
